import Gucci from '../assets/images/gucci.png';
import Hermes from '../assets/images/hermes.png';
import Ferragamo from '../assets/images/ferragamo.png';
import Louis from '../assets/images/louis.png';
import Balenciaga from '../assets/images/balenciaga.png';

export const carePartners = [
  {
    image: Gucci,
    alt: 'Gucci',
  },
  {
    image: Hermes,
    alt: 'Hermes',
  },
  {
    image: Ferragamo,
    alt: 'Ferragamo',
  },
  {
    image: Louis,
    alt: 'Louis Vuitton',
  },
  {
    image: Balenciaga,
    alt: 'Balenciaga',
  },
];
